import * as React from 'react';
import { api, applyQueryString, handleApiError } from 'services/api';
import type {
  ScheduledProductRestrictionDataImportListEntry as ListEntry,
} from 'contracts/restricted-products/scheduled-data-imports';
import type { Pagination } from 'contracts/Pagination';
import type {
  Filters,
  PaginationControl,
} from 'hooks/store/scheduled-restricted-products-data-imports/use-scheduled-data-imports-search-params';

type Payload = {
  filters?: Filters;
  pagination?: PaginationControl;
}

type ScheduledImportsResponseBody = {
  data: ListEntry[];
  meta: Pagination;
}

export const useFetchScheduledRestrictedProductsDataImports = () => {
  const fetchScheduledImports = React.useCallback(async (payload?: Payload): Promise<ScheduledImportsResponseBody> => {
    try {
      const url = applyQueryString(
        '/restricted-materials/scheduled-res-data-imports',
        {
          ...payload?.filters,
          ...payload?.pagination,
        },
      );
      const { data } = await api.get<ScheduledImportsResponseBody>(url);

      return data;
    } catch (error) {
      throw handleApiError(error);
    }
  }, []);

  return {
    fetchScheduledImports,
  };
};
